import { WaterlilyClient, createQueryKeys } from '@/api/waterlily';

export interface FundingCalcPromptResponse {
  prompt: string;
  tokenEstimate: number;
  clientSummary: string;
}

export interface WizardFundingSourceListItem {
  fundingSourceId: string;
  kind: 'ltcPolicy' | 'selfFunding';
  primaryLabel: string;
  secondaryLabel: string;
}

export interface WizardFundingSourcesResponse {
  clientSummary: string;
  fundingSources: WizardFundingSourceListItem[];
}

export const fundingCalcPromptKeys = createQueryKeys('wizardFundingCalcPrompt');
export const fundingSourcesKeys = createQueryKeys('wizardFundingSources');

export const fundingCalcPromptApi = {
  getByClientId: (clientId: string, fundingSourceId?: string) => {
    const qs = fundingSourceId
      ? `?fundingSourceId=${encodeURIComponent(fundingSourceId)}`
      : '';
    return WaterlilyClient.get<FundingCalcPromptResponse>(
      `/wizard-funding-calc-prompt/${clientId}${qs}`,
    );
  },
  listFundingSources: (clientId: string) =>
    WaterlilyClient.get<WizardFundingSourcesResponse>(
      `/wizard-funding-sources/${clientId}`,
    ),
};
